"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  SLOT_INTERVAL: 30,
  // 30 mins
  T_PLUS_4: 4,
  // 4 hrs
  T_PLUS_240_M: 240,
  //  240 min = 4 hrs
  MAX_PICKUP: 90,
  // 90 days,
  MAX_RENTAL: 1,
  // 1 year
  MINS_APART: 30 // 30 mins apart if pick and drop dates are same
};